import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { TutorialDialogComponent } from "./components";

@NgModule({
  declarations: [TutorialDialogComponent],
  imports: [SharedModule],
  exports: [],
})
export class TutorialsModule {}
